module.exports=function(e){var t={};function n(a){if(t[a])return t[a].exports;var r=t[a]={i:a,l:!1,exports:{}};return e[a].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,a){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:a})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var a=Object.create(null);if(n.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(a,r,function(t){return e[t]}.bind(null,r));return a},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=64)}({1:function(e,t){e.exports=require("react")},10:function(e,t){e.exports=require("../../styles/breakpoints")},2:function(e,t){e.exports=require("styled-components")},3:function(e,t){e.exports=require("../../styles")},5:function(e,t){e.exports=require("../Icon/Icon")},64:function(e,t,n){"use strict";var a=this&&this.__createBinding||(Object.create?function(e,t,n,a){void 0===a&&(a=n),Object.defineProperty(e,a,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,a){void 0===a&&(a=n),e[a]=t[n]}),r=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),i=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)"default"!==n&&Object.hasOwnProperty.call(e,n)&&a(t,e,n);return r(t,e),t},o=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const l=i(n(1)),u=i(n(2)),d=n(3),s=o(n(5)),c=o(n(10)),{KineduPalette:f}=d.colorPalettes,p=u.default.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${({isMenuOpen:e})=>e&&u.css`
      overflow: hidden;
    `}
`,h=u.default.div`
  display: flex;
  flex: 1;
  height: 100%;
`,m=u.default.div`
  width: 0px;
  height: 100%;
  background-color: ${f.shadeLighter};
  box-shadow: 10px 0px 7px -8px rgba(0, 0, 0, 0.2);
  overflow: auto;
  z-index: 999999;
  position: fixed;

  @keyframes entering {
    0% {
      width: 0px;
      transform: translateX(-256px);
    }
    1% {
      width: 256px;
    }
    100% {
      width: 256px;
      transform: translateX(0px);
    }
  }

  @keyframes leaving {
    0% {
      width: 256px;
      transform: translateX(0px);
    }
    99% {
      width: 256px;
      transform: translateX(-256px);
    }
    100% {
      width: 0px;
    }
  }

  ${({show:e,control:t})=>e?u.css`
        animation: entering 0.5s 1 forwards;

        ${c.default.largeTablet} {
          animation: none;
          /* animation: entering 0s 1 forwards; */
          width: 256px;
        }
      `:!e&&t?u.css`
        animation: leaving 0.5s 1 forwards;

        ${c.default.largeTablet} {
          animation: none;
          /* animation: leaving 0s 1 forwards; */
          width: 0px;
        }
      `:u.css`
      animation: leaving 0.5s 1 forwards;
      ${c.default.largeTablet} {
        animation: none;
        width: 256px;
      }
    `}
`,g=u.default.div`
  background-color: white;
  cursor: default;
`,x=u.default.div`
  display: flex;
  align-items: center;
  padding: 10px 20px;
`,b=u.default.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: ${f.shadeMediumLight};
  border-radius: 100px;
  margin-right: 10px;
`,v=u.default.span`
  font-size: 18px;
  font-weight: bold;
  color: ${f.shadeDarker};
  letter-spacing: -0.5px;
  line-height: 24px;
  text-overflow: ellipsis;
  overflow: hidden;
`,w=u.default.div`
  background-color: ${f.shadeLight};
`,y=u.default.div`
  display: flex;
  align-items: center;
  height: 70px;
  padding: 0 20px;

  border-bottom: 1px solid ${f.shadeMediumLight};

  font-size: 14px;
  color: ${f.kineduShade};
  text-transform: uppercase;
  letter-spacing: 3px;
  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  svg {
    * {
      fill: ${f.kineduShade};
    }
    margin-right: 5px;
  }

  ${({active:e})=>e&&u.css`
      color: white;
      background-color: ${f.kineduShade};

      :hover {
        background-color: ${f.kineduShade};
      }

      svg {
        * {
          fill: white;
        }
      }
    `}
`,k=u.default.span``,$=u.default.div`
  display: flex;
  align-items: center;
  padding: 0 10px;

  height: 60px;
  background-color: white;

  .menu-icon-burger {
    z-index: 1;
  }

  ${c.default.largeTablet} {
    display: none;
  }
`,O=u.default.div`
  /* position: absolute; */
  width: 100%;

  ${({isMenuOpen:e})=>e&&u.css`
      height: calc(100% - 60px);
      overflow: hidden;
    `}

  ${c.default.largeTablet} {
    position: relative;
    width: auto;
    flex: 1;
    overflow: auto;
    margin-left: 256px;

    ${({isMenuOpen:e})=>e&&u.css``}
  }
`,E=u.default.div`
  display: none;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin-left: auto;
  border-radius: 100px;
  background-color: ${f.kineduShade};

  ${({show:e})=>e&&u.css`
      display: flex;
    `}
`,_=u.default.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.2);
  transition: 0.5s all ease;
  pointer-events: none;
  z-index: 99;

  ${({isMenuOpen:e})=>e&&u.css`
      opacity: 1;
      pointer-events: all;
    `}

  ${c.default.largeTablet} {
    display: none;
  }
`,M=({show:e,appName:t="Menu name",items:n,activeRoute:a,showEditButton:r=!0,showAvatar:i=!1,closeWhenNavigate:o=!0,beforeListRender:u=(()=>{}),afterListRender:d=(()=>{}),onItemClicked:c=(()=>{}),onEditClicked:f=(()=>{}),content:M=(()=>{})})=>{const[j,S]=l.useState(!1),[P,z]=l.useState(e),T=()=>z(!P),C=()=>{P&&o&&z&&z(!1)};return l.useEffect(()=>{z(e),e&&S(!0)},[e]),l.default.createElement(p,{isMenuOpen:P,className:"menu"},l.default.createElement($,{className:"menu-topbar"},l.default.createElement(s.default,{name:"burger",className:"menu-icon-burger",size:26,onClick:T})),l.default.createElement(h,{className:"menu-wrapper"},l.default.createElement(m,{show:P,control:j},l.default.createElement(g,null,l.default.createElement(x,null,i&&l.default.createElement(b,null),l.default.createElement(v,null,t),l.default.createElement(E,{onClick:()=>{f&&f(),C()},show:r},l.default.createElement(s.default,{size:32,name:"edit",color:"white"})))),u(),l.default.createElement(w,null,n.map((e,t)=>l.default.createElement(y,{key:t,active:a===e.route,onClick:()=>{C(),c(e)}},l.default.createElement(s.default,{name:e.icon,size:32}),l.default.createElement(k,null,e.title)))),d()),l.default.createElement(O,{isMenuOpen:P},l.default.createElement(_,{onClick:T,isMenuOpen:P}),M())))};M.defaultProps={},t.default=M}});